var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-2"},[_c('div',[(_vm.questionTest)?[_c('AnswerTestContainer',{attrs:{"question_test_id":_vm.questionTest.id}})]:_c('h4',[_vm._v("Este examen no ha sido creado.")])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }